import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, model, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Product } from '../../../../generated/generated-types';
import { VendorProductPriceEditWidgetComponent } from '../vendor-product-price-edit-widget/vendor-product-price-edit-widget.component';

@Component({
  selector: 'app-formly-vendor-product-price-edit-widget',
  templateUrl: './formly-vendor-product-price-edit-widget.component.html',
  standalone: true,
  imports: [
    VendorProductPriceEditWidgetComponent,
    CommonModule,
    TranslatePipe,
  ]
})
export class FormlyVendorProductPriceEditWidgetComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {

  product = model<Product>(null);
  destroyRef = inject(DestroyRef);

  dataTestid = signal<string>("formly-vendor-product-price-edit-widget");

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }


  ngOnInit(): void {

    this.product.set(this.model);
    this.form?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
      this.product.set(this.model);
    });
  }

  ngAfterViewInit(): void {
    this.dataTestid.set(this.props.attributes['data-testid'].toString());
  }
}